<div>
<nx-pageTitle-box
  [label]="group?.name"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'settings'"
  [bcRootLvl1Label]="'Gruppen'"
  [bcRootLvl1Path]="'/settings/groups'"
  [icon]="'icon-person'"
  [iconToolTip]="'Gruppe'">
  <ng-template nxTemplate="end">
    <nx-default-button
      (click)="deleteGroup()"
      [style]="'transparent'"
      [tooltip]="'Gruppe löschen'"
      [label]="'Gruppe löschen'">
    </nx-default-button>
  </ng-template>
</nx-pageTitle-box>

  <p-tabView [scrollable]="true">
    <p-tabPanel header="Allgemein">
      <div class="flex flex-row gap-4 mt-2">
      <div
        class="basis-1/2">
        <nx-headline-box
          [label]="'Gruppendaten'">
          <ng-template nxTemplate="end">
            <nx-default-button
              (click)="editGroup()"
              [tooltip]="'Gruppe bearbeiten'"
              [icon]="'icon-edit'"
              [style]="'light'">
            </nx-default-button>
          </ng-template>
        </nx-headline-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Name'">
          {{group?.name}}
        </nx-default-box>
      </div>
      <div
        class="basis-1/2">
      </div>
    </div>
    </p-tabPanel>
    <p-tabPanel header="Rollen">

      <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
        <div class="flex-1 flex flex-row items-center ml-3 font-medium">
          Rollenliste
        </div>
        <div class="flex-none flex flex-row justify-center items-center">
          <div *ngIf="!selectedRoles || selectedRoles?.length === 0"
            class="bg-white text-base pt-[0.25rem] pb-[0.188rem] px-[0.313rem] opacity-50 rounded-md">
            Keine ausgewählt
          </div>
          <div *ngIf="selectedRoles?.length > 0"
            class="bg-white text-base pt-[0.25rem] pb-[0.188rem] px-[0.313rem] rounded-md">
            {{selectedRoles?.length}} ausgewählt
          </div>
          <nx-default-button
            [tooltip]="'Rollen entfernen'"
            [disabled]="!selectedRoles || selectedRoles?.length === 0"
            (click)="removeRoles()"
            [style]="'light'"
            [label]="'entfernen'"
            class="ml-2">
          </nx-default-button>
        </div>
        <div class="flex-1 flex flex-row justify-end items-center">
          <input
          pInputText
          type="text"
          (input)="$any(roleTable).filterGlobal($event.target?.['value'], 'contains')"
          class="p-inputtext p-component p-element mr-3"
        placeholder="Rolle suchen" />
        <nx-default-button
          [style]="'light'"
          class="mr-2"
          (click)="addRoles()"
          [label]="'Rollen hinzufügen'"
          [icon]="'icon-plus'">
        </nx-default-button>
        </div>
      </div>


      <p-table
        #roleTable
        [value]="groupRolesFiltered"
        [scrollable]="true"
        [paginator]="true"
        [(selection)]="selectedRoles"
        [rows]="15"
        [rowsPerPageOptions]="[15, 20, 50]"
        [totalRecords]="groupRoles?.length"
        [showCurrentPageReport]="true"
        [filterDelay]="200"
        [rowSelectable]="isRowSelectableFunction"
        currentPageReportTemplate="{first} - {last} von {totalRecords}"
        [globalFilterFields]="['label']"
        [resizableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Name</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-role>
          <tr>
            <td>
              <p-tableCheckbox [value]="role" [disabled]="role.isInherited" ></p-tableCheckbox>
            </td>
            <td>{{role.label}}</td>
            <td class="text-right">
              <nx-default-button
                [disabled]="role.isInherited"
                [tooltip]="'Rolle entfernen'"
                [style]="'dark'"
                (click)="role.isInherited ? null : removeRole(role)"
                [label]="'entfernen'">
              </nx-default-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="emptyMessage">Keine Rollen gefunden.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

  </p-tabView>

